import styled, { css } from 'styled-components';
import GridContainer from '@r1-frontend/ui-react/components/layouts/gridContainer';
import { FlexBoxCol, FlexBoxRow } from '@r1-frontend/ui-react/components/layouts/flexBoxGrid';
import { fonts } from '~/src/helpers/font';
import Button from '~/src/components/LandingBlock/Common/Button';
import { breakPoints, styleWithBreakPoints, CSSPropWithBreakpoints, blockMargin } from '~/src/components/LandingBlock/styled';

export interface IInfoBlockStyles {
    [key: string]: CSSPropWithBreakpoints;
}

export const Wrapper = styled.div<{ [key: string]: string }>`
    padding: 70px 0;
    position:relative;
    background: ${p => p.background ? `url(${p.background}) no-repeat center / cover` : 'transparent'};
    width: 100%;
       
    @media (max-width: ${breakPoints.desktop}) {
        
        margin-left: 0;
        margin-right: 0;
    }
    
    @media (max-width: ${breakPoints.sDesktop}) {
        overflow: hidden;   
    }
    
    @media (max-width: ${breakPoints.mobile}) {
        margin-top: 50px;
    }
    
    ${p => blockMargin(p)}; 
    ${p => styleWithBreakPoints(p, 'InfoBlock')};
`;

export const Grid = styled(GridContainer)`
    display: flex;
    max-width: 100%;
`;

export const Row = styled(FlexBoxRow)`
    width: 100%;
    justify-content: space-between;
`;

export const Col = styled(FlexBoxCol)`
    @media (max-width: ${breakPoints.mobile}) {
        margin-bottom: 30px;
    }
`;

export const Subtitle = styled.div`
    font: ${fonts.S};
    
    @media (max-width: ${breakPoints.sDesktop}) {
        white-space: pre-wrap;
    }
    
    @media (max-width: ${breakPoints.tablet}) {
        white-space: normal;
        font: ${fonts.S};
    }

    ${p => styleWithBreakPoints(p, 'InfoBlock.SubTitle')};
`;

export const Title = styled.div`
    font: ${fonts.H2};
    margin-bottom: 10px;
    white-space: pre-wrap;
    
    @media (max-width: ${breakPoints.tablet}) {
        font: ${fonts.H2};
    }
    
    @media (max-width: ${breakPoints.mobile}) {
        white-space: normal;
        font: ${fonts.H3};
    }

    ${p => styleWithBreakPoints(p, 'InfoBlock.Title')};
`;

export const Text = styled.div`
    font: ${fonts.L};
    
    @media (max-width: ${breakPoints.sDesktop}) {
        white-space: pre-wrap;
    }
    
    @media (max-width: ${breakPoints.tablet}) {
        white-space: normal;
        font: ${fonts.M};
    }

    ${p => styleWithBreakPoints(p, 'InfoBlock.Text')};
`;

export const BtnWrap = styled.div`
    margin-top: 32px;
    
    @media (max-width: ${breakPoints.mobile}) {
        margin-bottom: 100px;
    }

    @media (max-width: 535px) {
        margin-top: 60px;
    }
`;

export const Btn = styled(Button)`
    display: block;
    border-radius: 4px;
    margin-top: 24px;

    ${p => styleWithBreakPoints(p, 'InfoBlock.Button')};
    ${p => styleWithBreakPoints(p, 'InfoBlock.Button.Text')};
`;

interface IImage{
    paddingTop?: string;
    paddingRight?: string;
}

export const Image = styled.div<IImage>`
    max-width: 358px;
    height: 100%;
    margin-left: auto;
    position: relative;
    ${({ paddingTop }) => paddingTop ? css`top: ${paddingTop};` : null}
    ${({ paddingRight }) => paddingRight ? css`right: ${paddingRight};` : null}
    
    @media (max-width: ${breakPoints.mobile}) {
        flex-basis: 100%;
        max-width: 100%;
        margin-top: 29px;
        margin-right: auto;
    }
    
    img {
        display: block;
        width: 100%;
        
        @media (max-width: ${breakPoints.mobile}) {
            margin: auto;
            max-width: 100%;
            height: auto;
        }
    }

    ${p => styleWithBreakPoints(p, 'InfoBlock.Image')};
`;
